import React, {useState} from 'react';

// The marketplace's own site icon. Logo files are not in the repo, so the icon comes from the site's
// favicon; when it does not load, a badge with the marketplace's initial stands in.
const SITES = {
    amazon: 'amazon.com.tr', bauhaus: 'bauhaus.com.tr', hepsiburada: 'hepsiburada.com', idefix: 'idefix.com',
    koctas: 'koctas.com.tr', n11: 'n11.com', trendyol: 'trendyol.com',
};
const COLORS = {amazon: '#ff9900', hepsiburada: '#ff6000', koctas: '#e30613', trendyol: '#f27a1a'};

export const marketplaceIconUrl = (key) =>
    SITES[key] ? `https://www.google.com/s2/favicons?domain=${SITES[key]}&sz=64` : null;

const MarketplaceIcon = ({marketplaceKey, label, size = 32}) => {
    const [failed, setFailed] = useState(false);
    const url = marketplaceIconUrl(marketplaceKey);
    const box = {width: size, height: size, borderRadius: 8, flexShrink: 0};
    if (url && !failed) {
        return <img src={url} alt={label} onError={() => setFailed(true)}
                    style={{...box, objectFit: 'contain', background: '#fff', border: '1px solid #f1f5f9', padding: 3}}/>;
    }
    return <span aria-label={label} style={{
        ...box, background: COLORS[marketplaceKey] || '#64748b', color: '#fff', fontWeight: 700, fontSize: size * 0.45,
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center'}}>
        {(label || marketplaceKey || '?').charAt(0).toUpperCase()}
    </span>;
};

export default MarketplaceIcon;
